import { ApiCall } from "../../utils/index"
import { DEPTWITHUSERANDCOLLABORATORS, GETDEPARTMENT } from "../constants";

export const getDepartment = (cb, debouncedHandleSearch, page, row_count, sortField, sortOrder) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    let url = "/department/company"

    if(page) {
      const searchParam = debouncedHandleSearch ? `search=${debouncedHandleSearch}&` : "";
      const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
      url = url + params
    }

    const result = await ApiCall.get(url, token);

    dispatch({ type: GETDEPARTMENT, payload: result.data });

    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const createDepartment = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.post("/department", payload, token);

    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const updateDepartment =
  (id, payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.patch(`/department/${id}`, payload, token)

      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const deleteDepartment = (id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.delete(`/department/${id}`, token);

    cb(result);
  } catch (error) {
    cb(error);
  }
};


export const getDeptWithUserAndCollaborators = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get("/department/with_users", token);

    dispatch({ type: DEPTWITHUSERANDCOLLABORATORS, payload: result.data });

    request.onSuccess(result);
  } catch (error) {
    request.onError(error);
  }
};
